/**
 * MBA variant — shared LandingConnectModal controller with variant: "mba".
 */
"use client";

import {
  useLandingConnectModalFormController,
  type UseLandingConnectModalFormControllerOptions,
  type LandingConnectModalFormViewModel,
} from "../../LandingPageConnectModal/controller/useLandingConnectModalFormController";

export type UseLandingConnectModalFormMBAControllerOptions = Omit<
  UseLandingConnectModalFormControllerOptions,
  "variant"
>;

export function useLandingConnectModalFormMBAController(
  options: UseLandingConnectModalFormMBAControllerOptions,
): LandingConnectModalFormViewModel {
  return useLandingConnectModalFormController({
    ...options,
    variant: "mba",
  });
}
